import {gql} from 'apollo-angular';
import {StatusFragment} from "../queries/fragments/Status";

export const REMOVE_TEACHER_FROM_SCHOOL = gql`
  mutation RemoveTeacherFromSchool($teacherId: Int!) {
    removeSchoolTeacher(teacherID: $teacherId) {
      type
      message
    }
  }
`;
